<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn @click="back" text class="text_btn">
            <v-icon>keyboard_arrow_left</v-icon>back
          </v-btn>
        </v-flex>
        <v-flex xs6></v-flex>
      </v-layout>
      <h1>Messaging settings ({{ p_name }})</h1>
      <p>Change here the server side settings to setup the Firebase Cloud Messaging service.</p>
      <v-form @submit="saveMessagingSettings">
        <v-layout row wrap>
          <v-flex sm6>
            <span>Provide here the Firebase Cloud Messaging server key, created in the Google developer console.</span>
            <p>You can find the server key <a href="https://console.firebase.google.com/project/_/settings/cloudmessaging/" target="_blank">here</a>.</p>
            <v-text-field type="text" label="FCM Server Key" v-model="f_setting_fcm_server_key" />
            <v-btn type="submit">
              <v-icon>save</v-icon>save
            </v-btn>
          </v-flex>
          <v-flex sm6></v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { MessagingSettings } from "../logic/MessagingSettings";
import { Notifications } from '../notification';
import { Projects } from "../logic/Projects";

export default {
  name: "MessagingSettings",
  data() {
    return {
      p_name: "...",
      project_id: 0,

      f_setting_fcm_server_key: ""
    };
  },
  mounted() {
    this.project_id = this.$route.params.project_id;

    this.setTitle("Messaging Settings");

    this.loadProjectMeta(this.project_id);
    this.loadMessagingSettings();
  },
  methods: {
    async loadProjectMeta(project_id) {
      var project_response = await Projects.get(project_id);
      if (project_response.status === 200) {
        if (Array.isArray(project_response.body) && project_response.body.length > 0) {
          this.p_name = project_response.body[0].name;
        } else if (project_response.body && project_response.body.name) {
          this.p_name = project_response.body.name;
        }
      }
    },
    async loadMessagingSettings() {
        var response = await MessagingSettings.load(this.project_id);
        if (response.status === 200) {
            this.f_setting_fcm_server_key = response.body.fcm_server_key;
        }
    },
    async saveMessagingSettings(e) {
      e.preventDefault();
      
      var response = await MessagingSettings.save(this.project_id, this.f_setting_fcm_server_key);
      if (response.status === 200) {
          Notifications.show("The settings has been saved successfully.");
      } else {
          Notifications.show(response.message)
      }
    },
    back() {
      this.$router.replace("/project/" + this.project_id);
    }
  }
};
</script>

<style>
</style>